// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"36ca82df","388":"36ca82df","473":"36ca82df","513":"36ca82df","582":"36ca82df","785":"36ca82df"}[chunkId] + ".chunk.css";
};